export const primaryColor = '#3B7AA7';